<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Table Extraction to .docx File</h1>
      <p>
        It is possible to extract the Analytical SII & SPI Tables into a DOCX file, using the corresponding <b>button on the
        top-right of the screen.</b> This button stays at a fixed position on the top-right corner for as long as the user scrolls
        through the tables.
      </p>

      <div class="image-container">
        <img src="@/images/manual/table-to-docx-extraction-button.png" alt="table extraction button" />
        <div class="img-caption">
          Figure 1. The Location of the Table Extraction to DOCX button.
        </div>
      </div>

      <p>
        Once the button is clicked, a pre-confirm prompt will appear in order to select the Aggregation Levels to be included
        in the report. All Aggregation Levels selected will be included in <b>both in the SII and the SPI Analysis</b>.
        If, for example, the user selects to <b>only</b> include the <b>PEB level</b>, then there will be <b>two tables included
        in the report.</b> The PEB Level SII scores and the PEB Level SPI scores.
      </p>

      <div class="image-container">
        <img src="@/images/manual/table-extraction-modal.png" alt="extraction prompt" />
        <div class="img-caption">
          Figure 2. The pre-extraction prompt.
        </div>
      </div>

      <p>
        <b>Αt least one</b> Aggregation Level must be selected, otherwise the report cannot be exported.
        If the user deselects all the Aggregation Levels, an informative message will appear at the top of the modal.
      </p>

      <div class="image-container">
        <img src="@/images/manual/table-extraction-invalid-modal.png" alt="invalid extraction prompt" />
        <div class="img-caption">
          Figure 3. A wrong selection of Aggregation Levels.
        </div>
      </div>

      <p>
        Once the preferred Aggregation Levels are selected, the "Download" button becomes active and can be
        clicked. When clicked, a file named "table.docx" will be downloaded. The following image is an indicative
        example of a report regarding the POCITYF Project using only the Building Aggregation Level. The report also
        includes the user's email, the export date of the report, and the project's name.
      </p>

      <div class="image-container">
        <img src="@/images/manual/docx-intro.png" alt="docx intro" />
        <div class="img-caption">
          Figure 4. The document's first information.
        </div>
      </div>

      <p>
        The rest of the table is pretty similar to the "Analytical Table KPI Scores" section; all the rows and scores are
        depicted in the same manner. The only difference is that the Aggregation Levels must be selected beforehand.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/docx-sii-table.png" alt="docx sii table" />
          </v-col>
          <v-col>
            <img src="@/images/manual/docx-spi-table.png" alt="docx spi table" />
          </v-col>
        </v-row>
        <div class="img-caption">
          Figure 5. Analytical SII Scores (left) and Analytical SPI Scores (right) extracted in a docx file.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
